export function toLocalDateString(value: Date | string | null | undefined): string | null {
  if (!value) {
    return null;
  }

  if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
    return value;
  }

  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) {
    return null;
  }

  const year = date.getFullYear();
  const month = `${date.getMonth() + 1}`.padStart(2, '0');
  const day = `${date.getDate()}`.padStart(2, '0');

  return `${year}-${month}-${day}`;
}

export function parseLocalDate(value: Date | string | null | undefined): Date | null {
  const str = toLocalDateString(value);
  if (!str) {
    return null;
  }

  const [year, month, day] = str.split('-').map(Number);
  return new Date(year, month - 1, day);
}

export const DATE_FORMAT = 'dd-MM-yyyy';
